import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { UserSetPasswordSettingsInput } from '../..'
import { passwordSettingsOptions } from './password-settings.options'
import { setPasswordSettings } from './password-settings.service'

export const usePasswordSettings = (enabled = true) => {
  return useQuery(passwordSettingsOptions(enabled))
}

export const useSetPasswordSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UserSetPasswordSettingsInput) =>
      setPasswordSettings(data),
    onSuccess: () => {
      // Invalidate and refetch password settings after successful update
      queryClient.invalidateQueries({ queryKey: ['password-settings'] })
    },
  })
}
